<template>
    <div>
        <!-- Type -->
        <div class='row'>
            <div class='col-md-3'><strong>Object</strong></div>
            <div class='col-md-9'>Association</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['object'],
    };
</script>
